module.exports = __webpack_public_path__ + "static/media/music-button.4fd0ef7d.png";